import { useEffect, useState } from 'react'

// Компонент для отображения иконок талантов
const TalentIcon = ({ talentId, name }) => {
  const [svgContent, setSvgContent] = useState(null)
  const [error, setError] = useState(false)

  // Базовые свойства SVG
  const svgProps = {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg',
  }

  // Функция для получения цвета по ID таланта
  const getIconColor = (id) => {
    const colors = [
      '#10BDC8', // Основной цвет
      '#1cc88a', // Зеленый
      '#4e73df', // Синий
      '#f6c23e', // Желтый
      '#e74a3b', // Красный
      '#36b9cc', // Голубой
      '#6f42c1', // Фиолетовый
      '#fd7e14', // Оранжевый
    ]

    const colorIndex = (id - 1) % colors.length
    return colors[colorIndex]
  }

  // Загрузка SVG файла для таланта
  useEffect(() => {
    const fetchSvg = async () => {
      try {
        // Добавляем timestamp для предотвращения кэширования
        const timestamp = new Date().getTime()
        const svgUrl = `/Evoicon/${talentId}.svg?v=${timestamp}`

        console.log(`Загрузка иконки для таланта ${talentId}: ${svgUrl}`)

        const response = await fetch(svgUrl)
        if (!response.ok) {
          throw new Error(`Не удалось загрузить SVG: ${response.status}`)
        }

        const svgText = await response.text()
        setSvgContent(svgText)
      } catch (err) {
        console.error(`Ошибка загрузки SVG для таланта ${talentId}:`, err)
        setError(true)
      }
    }

    fetchSvg()
  }, [talentId])

  // Если SVG успешно загружен, отобразим его в качестве иконки
  if (svgContent && !error) {
    return <div className="talent-icon" dangerouslySetInnerHTML={{ __html: svgContent }} />
  }

  // Если нет ни загруженной, ни встроенной иконки - отображаем стандартную с номером
  return (
    <svg {...svgProps}>
      <circle cx="16" cy="16" r="14" fill={getIconColor(talentId)} opacity="0.2" />
      <circle cx="16" cy="16" r="12" stroke={getIconColor(talentId)} strokeWidth="2" fill="none" />
      <text
        x="16"
        y="20"
        textAnchor="middle"
        dominantBaseline="middle"
        fill={getIconColor(talentId)}
        fontSize="14"
        fontWeight="bold"
      >
        {talentId}
      </text>
    </svg>
  )
}

export default TalentIcon
